import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetSearchingResultsLoading, EGetSearchingResultsActionType } from './types';

export const getSearchingResultsLoading: () => TGetSearchingResultsLoading =
  actionGenerator<EGetSearchingResultsActionType.Loading>(EGetSearchingResultsActionType.Loading);
